export default __webpack_public_path__ + "static/media/CNo.33-7.8c74eb24.jpg";